import React from 'react'
import { connect } from 'react-redux'
import { tipoImpressaoCupom } from '../../util/constantsUtil'
import ModalImpressaoCupomEncomenda from '../encomenda/ModalImpressaoCupomEncomenda'
import ReciboCupomEncomendaAvulsa from './ReciboCupomEncomendaAvulsa'

function exibirCupom (encomenda, via) {
  return (
    <div className="card mb-2">
      <div className="card-body">
        <div className="d-flex justify-content-between flex-wrap">
          <span>{encomenda.nomeEmpresa}</span>
          <span>Via: {via}</span>
          <span>Pedido: {encomenda.numeroPedido} · OS: {encomenda.numeroOs}</span>
        </div>
        <h5 className="mt-2">Rota: {encomenda.cidadeOrigem} à {encomenda.cidadeDestino}</h5>
        <div>Itinerário: {encomenda.descricaoRotaItinerario} - {encomenda.dataItinerario}</div>
        <hr/>
        <div className="row">
          <div className="col-6">
            <strong>Remetente:</strong> {encomenda.nomeRemetente}<br/>
            Telefone: {encomenda.telefoneRemetente}
          </div>
          <div className="col-6">
            <strong>Destinatário:</strong> {encomenda.nomeDestinatario}<br/>
            Telefone: {encomenda.telefoneDestinatario}
          </div>
        </div>
        <hr/>
        <div>Descrição do produto: {encomenda.descricao}</div>
        <div>Volumes: {encomenda.volumes}</div>
        <div>Formas de pagamento: {encomenda.descricaoFormaPagamento}</div>
        <div>Valor total: R$ {encomenda.valor}</div>
        <hr/>
        <div>Vendedor: {encomenda.codigoVendedor} - {encomenda.nomeVendedor}</div>
        <div>Data/hora da venda: {encomenda.dataHoraVenda}</div>
        {encomenda.situacao === 'CANCELADA' && (
          <div className="text-danger font-weight-bold mt-2">CANCELADA - {encomenda.cancelamentoMotivo}</div>
        )}
      </div>
    </div>
  )
}

function exibirReciboEntrega (encomenda) {
  return (
    <div className="card mb-2">
      <div className="card-header text-center"><strong>RECIBO DE ENTREGA</strong></div>
      <div className="card-body">
        <p>Declaro haver recebido as mercadorias referentes à OS informada acima.</p>
        <p>OS: {encomenda.numeroOs}</p>
        <div className="mt-4">Assinatura: <div style={{ borderBottom: '1px solid black', height: 20 }}/></div>
        <div className="mt-3">RG: <div style={{ borderBottom: '1px solid black', height: 20 }}/></div>
        <div className="mt-3">Nome: <div style={{ borderBottom: '1px solid black', height: 20 }}/></div>
        <div className="mt-3">CPF: <div style={{ borderBottom: '1px solid black', height: 20 }}/></div>
        <div className="mt-3 d-flex justify-content-between">
          <span>Data: ____/____/______</span>
          <span>Horário: ____:____</span>
        </div>
      </div>
    </div>
  )
}

function exibirEtiquetas (encomenda) {
  if (!encomenda.volumes) return null
  return [...Array(encomenda.volumes).keys()].map(i => (
    <React.Fragment key={`volume-encomenda-avulsa-${i}`}>
      <div className="card mb-2">
        <div className="card-body">
          <h5><strong>Rota: </strong>{encomenda.cidadeOrigem} à {encomenda.cidadeDestino}</h5>
          <div>Itinerário: {encomenda.descricaoRotaItinerario}</div>
          <h2 className="mt-3">Destino:</h2>
          <strong style={{ fontSize: 50 }}>{encomenda.cidadeDestino}</strong>
          <h5 className="mt-3">Volume: {i + 1}/{encomenda.volumes}</h5>
          <h5>Pedido: {encomenda.numeroPedido} · OS: {encomenda.numeroOs}</h5>
          <h2 className="mt-3">Destinatário:</h2>
          <strong style={{ fontSize: 50 }}>{encomenda.nomeDestinatario}</strong>
          <div>Tel: {encomenda.telefoneDestinatario}</div>
        </div>
      </div>
      {i + 1 !== encomenda.volumes && <hr style={{ borderTop: '2px dashed' }}/>}
    </React.Fragment>
  ))
}

class ReciboEncomendaAvulsa extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      referencias: null,
      pagina: null,
      referenciasCheckeds: [],
      refComponent: React.createRef(),
      isOpenModal: false,
      tipoImpressaoCupom: tipoImpressaoCupom.normal
    }
  }

  componentDidMount () {
    if (this.props.encomendaAvulsa) {
      this.getReferencias(this.props.encomendaAvulsa)
      this.setState({ pagina: window })
    }
  }

  getReferencias (encomenda) {
    const ref = new Map()
    ref.set('REMETENTE', {
      id: 'remetente',
      nome: `Remetente: ${encomenda.nomeRemetente}`,
      nomeParaImpressao: encomenda.nomeRemetente,
      referencia: React.createRef()
    })
    ref.set('DESTINATARIO', {
      id: 'destinatario',
      nome: `Destinatário: ${encomenda.nomeDestinatario}`,
      nomeParaImpressao: encomenda.nomeDestinatario,
      referencia: React.createRef()
    })
    ref.set('AGENCIA', {
      id: 'agencia',
      nome: 'via agência',
      nomeParaImpressao: 'via agência',
      referencia: React.createRef()
    })
    ref.set('ENTREGA', {
      id: 'entrega',
      nome: 'via entrega',
      nomeParaImpressao: 'via entrega',
      referencia: React.createRef()
    })
    ref.set('RECIBO_DE_ENTREGA', {
      id: 'recibo_de_entrega',
      nome: 'recibo de entrega',
      nomeParaImpressao: 'recibo de entrega',
      referencia: React.createRef()
    })

    this.setState({
      referencias: ref,
      referenciasCheckeds: [...ref.keys()].map(it => ({ key: it, checked: false }))
    })
  }

  marcarReferencia (key) {
    const referenciasCheckeds = Object.assign([], this.state.referenciasCheckeds)
    if (referenciasCheckeds.filter(it => it.key === key)[0].checked) {
      referenciasCheckeds.forEach(it => { if (it.key === key) it.checked = false })
    } else {
      referenciasCheckeds.forEach(it => { if (it.key === key) it.checked = true })
    }
    this.setState({ referenciasCheckeds })
  }

  limparMarcacaoReferenciasCheckeds () {
    const referenciasCheckeds = [...this.state.referenciasCheckeds]
    referenciasCheckeds.forEach(it => { it.checked = false })
    this.setState({ referenciasCheckeds })
  }

  setTipoImpressaoCupom (tipo) {
    this.setState({ tipoImpressaoCupom: tipo })
  }

  habilitarDesabilitarReciboCupomEncomenda (valor) {
    this.setState({ isOpenModal: valor })
  }

  apresentarReciboCupomTermica () {
    return this.state.isOpenModal && this.state.tipoImpressaoCupom === tipoImpressaoCupom.termica
  }

  render () {
    const encomenda = this.props.encomendaAvulsa

    if (!encomenda) {
      return (
        <div className="row internas">
          <p>Nenhuma encomenda avulsa selecionada para impressão.</p>
        </div>
      )
    }

    return (
      <div className="row internas">
        <style>{'@media print { .vx-no-print { display: none !important; } .pagebreak { page-break-before: always; } }'}</style>

        <div className="col-12" id="cupom-encomenda-avulsa">
          <div style={{ maxWidth: 480, margin: '0 auto' }}>
            {exibirCupom(encomenda, 'Remetente')}
            {exibirCupom(encomenda, 'Agência')}
            <div className="pagebreak"/>
            {exibirCupom(encomenda, 'Destinatário')}
            {exibirCupom(encomenda, 'Entrega')}
            {exibirReciboEntrega(encomenda)}
            <div className="pagebreak"/>
            {exibirEtiquetas(encomenda)}
          </div>

          <div className="text-center mt-3 vx-no-print">
            <a className="vx-btn-primary" style={{ cursor: 'pointer' }} data-toggle="modal"
               data-target="#modalImpressaoCupomEncomenda"
               onClick={() => this.habilitarDesabilitarReciboCupomEncomenda(true)}>
              <i className="material-icons">print</i> Imprimir
            </a>
          </div>
        </div>

        {this.apresentarReciboCupomTermica() && (
          <div ref={this.state.refComponent} className="printer-ticket ReciboCupomEncomendaAvulsa">
            <ReciboCupomEncomendaAvulsa referencias={this.state.referencias} encomenda={encomenda} empresaSelecionada={this.props.empresaSelecionada} />
          </div>
        )}

        <ModalImpressaoCupomEncomenda
          referencias={this.state.referencias}
          referenciasCheckeds={this.state.referenciasCheckeds}
          pagina={this.state.pagina}
          marcarReferencia={this.marcarReferencia.bind(this)}
          limparMarcacaoReferenciasCheckeds={this.limparMarcacaoReferenciasCheckeds.bind(this)}
          refComponent={this.state.refComponent}
          isOpenModal={this.state.isOpenModal}
          tipo={this.state.tipoImpressaoCupom}
          setTipoImpressaoCupom={this.setTipoImpressaoCupom.bind(this)}
          habilitarDesabilitarReciboCupomEncomenda={this.habilitarDesabilitarReciboCupomEncomenda.bind(this)} />
      </div>
    )
  }
}

const mapStateToProps = state => ({
  encomendaAvulsa: state.encomendaAvulsa,
  empresaSelecionada: state.empresaSelecionada
})

export default connect(mapStateToProps)(ReciboEncomendaAvulsa)
